<div class="container">
  <div class="head">
    <div class="head-label" mat-dialog-title>
      {{ title }}
    </div>
    <mat-icon class="head-exit" mat-dialog-close="">close</mat-icon>
  </div>

  <div class="content">
    <div *ngIf="!isLoading; else loader">
      <div *ngFor="let group of sortedOriginalGroups">
        <div class="selectable-group">
          <mat-checkbox (change)="handleCheckGroup(group, $event.checked)"
                        [checked]="isChecked(group)">
            {{ group.name }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <ng-template #loader>
      <div>
        {{ 'COMMON.LOADING' | translate }}
      </div>
    </ng-template>
  </div>
  <button (click)="save()"
          *ngIf="hasChanged"
          class="submit-button"
          color="primary"
          mat-raised-button>{{ 'COMMON.SAVE' | translate }}</button>
</div>
